import get from 'lodash/get';
import * as personIndexSectionPageActions from '../../action_creators/mcp/person_index_section_page_action_creators';
import log from '../../../services/logger_service';
import asyncPersonIndexSectionActions from './async_person_index_section_actions';
import asyncPersonIndexSectionNextActions from './async_person_index_section_next_actions';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function fetchPersonPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(
      personIndexSectionPageActions.personIndexSectionPageLoading({}, store)
    );
    return Promise.all([
      asyncPersonIndexSectionActions(params, store)(dispatch),
      asyncPersonIndexSectionNextActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function handlePostDetailData() {
        dispatch(
          personIndexSectionPageActions.personIndexSectionPageLoaded({}, store)
        );
        return true;
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in tag page actions, message: ${err.message}`);
        }
        dispatch(
          personIndexSectionPageActions.personIndexSectionPageLoadError(
            err,
            store
          )
        );
      });
  };
}
